/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './surgical-appointment-attribute.reducer';

export const SurgicalAppointmentAttributeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const surgicalAppointmentAttributeEntity = useAppSelector(state => state.surgicalAppointmentAttribute.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="surgicalAppointmentAttributeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttribute.detail.title">SurgicalAppointmentAttribute</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttribute.id">Id</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentAttributeEntity.id}</dd>
          <dt>
            <span id="value">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttribute.value">Value</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentAttributeEntity.value}</dd>
          <dt>
            <span id="participantType">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttribute.participantType">Participant Type</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentAttributeEntity.participantType}</dd>
          <dt>
            <span id="participantId">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttribute.participantId">Participant Id</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentAttributeEntity.participantId}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttribute.active">Active</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentAttributeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttribute.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentAttributeEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttribute.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentAttributeEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttribute.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentAttributeEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttribute.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentAttributeEntity.timestampentry}</dd>
          <dt>
            <span id="addedById">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttribute.addedById">Added By Id</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentAttributeEntity.addedById}</dd>
          <dt>
            <span id="modifiedById">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttribute.modifiedById">Modified By Id</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentAttributeEntity.modifiedById}</dd>
          <dt>
            <span id="addedByType">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttribute.addedByType">Added By Type</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentAttributeEntity.addedByType}</dd>
          <dt>
            <span id="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttribute.modifiedByType">Modified By Type</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentAttributeEntity.modifiedByType}</dd>
          <dt>
            <span id="role">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttribute.role">Role</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentAttributeEntity.role}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttribute.schedule">Schedule</Translate>
          </dt>
          <dd>{surgicalAppointmentAttributeEntity.schedule ? surgicalAppointmentAttributeEntity.schedule.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttribute.attributeType">Attribute Type</Translate>
          </dt>
          <dd>{surgicalAppointmentAttributeEntity.attributeType ? surgicalAppointmentAttributeEntity.attributeType.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/surgical-appointment-attribute" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/surgical-appointment-attribute/${surgicalAppointmentAttributeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SurgicalAppointmentAttributeDetail;
